import { render, staticRenderFns } from "./DeploymentVideowall.vue?vue&type=template&id=4bae386e&"
import script from "./DeploymentVideowall.vue?vue&type=script&lang=js&"
export * from "./DeploymentVideowall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports